/* assets/littleg-upload-transport.js — FAMILY-NOTICE-TRANSPORT-10
   Canonical network/transport owner for the LittleG Upload Workspace.
It never owns persistent DOM, visual state, screen navigation or CSS. and authenticated F02 Route Readiness brief.
   Remote responses use { success, request_id, data|error }.
   Parse, packing and confirmation reuse deterministic logical request identifiers.
   Confirmation payload augmentation remains an ordered contributor pipeline.
   F02 sends only the existing private Notice record context to the authenticated no-store brief endpoint;
   origin coordinates, route duration/provider facts and Today/F03 state are never transported here.
   OCR fails closed. Local fallback is limited to offline/network/timeout/5xx failures for packing/confirmation only.
   Telemetry events contain no notice text, child data, tokens or payload bodies. */
(function (window, document) {
  'use strict';

  var VERSION = '2026-08-08-family-notice-transport-10';
  var existingTransport = window.LittleGUploadTransport;
  if (window.__LITTLEG_UPLOAD_TRANSPORT__ === VERSION && existingTransport) return;
  if (existingTransport && typeof existingTransport.dispose === 'function')
    existingTransport.dispose();
  window.__LITTLEG_UPLOAD_TRANSPORT__ = VERSION;

  var REQUEST_TIMEOUT_MS = 30000;
  var PATHS = Object.freeze({
    parse: '/api/mobile/notices/parse',
    packing: '/api/mobile/notices/generate-packing-list',
    confirm: '/api/mobile/notices/confirm',
    routeReadinessBrief: '/apps/gcity-api/core/mobile/family/route-readiness/brief',
  });
  var lastPersistence = 'none';
  var confirmContributors = new Map();

  var MESSAGES = {
    'zh-HK': {
      offline: '目前沒有網絡連線。',
      network: '網絡連線不穩定，請稍後重試。',
      timeout: '服務回應逾時，請稍後重試。',
      invalidResponse: '伺服器回應格式不正確。',
      missingData: '伺服器沒有返回可驗證資料。',
      requestFailed: '沒有取得可驗證的結果。',
      invalidFile: '請先選擇一份通告。',
      missingRouteRecord: '未找到已確認的私人通告記錄。',
      missingDestination: '通告未有可確認的用途地。',
      storageUnavailable: '未能連接家庭記錄儲存，沒有建立成功記錄。',
      localSaveFailed: '未能在此裝置保存家庭記錄。',
      suggestedNote: '小G根據已確認活動內容提出；家長可修改或移除。',
      localSaved: '已私人保存',
      localStatus: '已私人保存於此裝置；尚未同步後端。',
    },
    'zh-TW': {
      offline: '目前沒有網路連線。',
      network: '網路連線不穩定，請稍後重試。',
      timeout: '服務回應逾時，請稍後重試。',
      invalidResponse: '伺服器回應格式不正確。',
      missingData: '伺服器沒有回傳可驗證資料。',
      requestFailed: '沒有取得可驗證的結果。',
      invalidFile: '請先選擇一份通知。',
      missingRouteRecord: '未找到已確認的私密通知記錄。',
      missingDestination: '通知沒有可確認的用途地。',
      storageUnavailable: '無法連接家庭記錄儲存，沒有建立成功記錄。',
      localSaveFailed: '無法在此裝置儲存家庭記錄。',
      suggestedNote: '小G根據已確認的活動內容提出；家長可修改或移除。',
      localSaved: '已私密儲存',
      localStatus: '已私密儲存在此裝置；尚未同步後端。',
    },
    'zh-CN': {
      offline: '当前没有网络连接。',
      network: '网络连接不稳定，请稍后重试。',
      timeout: '服务响应超时，请稍后重试。',
      invalidResponse: '服务器响应格式不正确。',
      missingData: '服务器没有返回可验证数据。',
      requestFailed: '没有取得可验证的结果。',
      invalidFile: '请先选择一份通知。',
      missingRouteRecord: '未找到已确认的私密通知记录。',
      missingDestination: '通知没有可确认的用途地。',
      storageUnavailable: '无法连接家庭记录存储，没有建立成功记录。',
      localSaveFailed: '无法在此设备保存家庭记录。',
      suggestedNote: '小G根据已确认的活动内容提出；家长可修改或移除。',
      localSaved: '已私密保存',
      localStatus: '已私密保存在此设备；尚未同步后端。',
    },
    en: {
      offline: 'You are offline.',
      network: 'The connection is unstable. Try again shortly.',
      timeout: 'The service timed out. Try again shortly.',
      invalidResponse: 'The server response is invalid.',
      missingData: 'The server did not return verifiable data.',
      requestFailed: 'No verifiable result was returned.',
      invalidFile: 'Choose a school notice first.',
      missingRouteRecord: 'No confirmed private notice record was found.',
      missingDestination: 'The notice does not contain a confirmable destination.',
      storageUnavailable: 'Private family storage is unavailable, so no record was created.',
      localSaveFailed: 'The family record could not be saved on this device.',
      suggestedNote:
        'Suggested from parent-reviewed activity details. A parent can edit or remove it.',
      localSaved: 'Saved privately',
      localStatus: 'Saved privately on this device and not yet synced.',
    },
  };

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function locale() {
    var raw = clean(
      document.documentElement.lang || (window.Shopify && window.Shopify.locale) || 'zh-HK'
    ).toLowerCase();
    if (raw.indexOf('zh-cn') === 0 || raw.indexOf('zh-sg') === 0 || raw.indexOf('hans') !== -1)
      return 'zh-CN';
    if (raw.indexOf('zh-tw') === 0) return 'zh-TW';
    if (raw.indexOf('zh') === 0) return 'zh-HK';
    return 'en';
  }

  function message(key) {
    var table = MESSAGES[locale()] || MESSAGES.en;
    return table[key] || MESSAGES.en[key] || key;
  }

  function uid(prefix) {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function')
        return prefix + '-' + window.crypto.randomUUID();
    } catch (_) {}
    return prefix + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function cloneJson(value, fallback) {
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (_) {
      return fallback;
    }
  }

  function cloneConfirmInput(input) {
    var source = input && typeof input === 'object' ? input : {};
    return Object.assign({}, source, {
      notice: cloneJson(source.notice || {}, {}),
      packing_list: cloneJson(source.packing_list || {}, {}),
      checklist: cloneJson(Array.isArray(source.checklist) ? source.checklist : [], []),
    });
  }

  function stableSerialize(value) {
    if (value === null || typeof value !== 'object') return JSON.stringify(value);
    if (Array.isArray(value)) return '[' + value.map(stableSerialize).join(',') + ']';
    return (
      '{' +
      Object.keys(value)
        .sort()
        .map(function (key) {
          return JSON.stringify(key) + ':' + stableSerialize(value[key]);
        })
        .join(',') +
      '}'
    );
  }

  function fallbackHash(value) {
    var hash = 2166136261;
    var text = String(value || '');
    for (var index = 0; index < text.length; index += 1) {
      hash ^= text.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(16).padStart(8, '0');
  }

  function hex(bytes) {
    return Array.from(bytes)
      .map(function (byte) {
        return byte.toString(16).padStart(2, '0');
      })
      .join('');
  }

  async function sha256Text(value) {
    try {
      if (window.crypto && window.crypto.subtle && typeof window.TextEncoder === 'function') {
        var digest = await window.crypto.subtle.digest(
          'SHA-256',
          new window.TextEncoder().encode(String(value || ''))
        );
        return hex(new Uint8Array(digest));
      }
    } catch (_) {}
    return fallbackHash(value);
  }

  async function sha256Bytes(value, fallback) {
    try {
      if (window.crypto && window.crypto.subtle) {
        var digest = await window.crypto.subtle.digest('SHA-256', value);
        return hex(new Uint8Array(digest));
      }
    } catch (_) {}
    return fallbackHash(fallback || 'file');
  }

  async function stableRequestId(prefix, input, payload) {
    var explicit = clean(input && input.request_id);
    if (explicit) return explicit;
    var digest = await sha256Text(stableSerialize(payload));
    return prefix + '-' + digest.slice(0, 32);
  }

  async function stableParseIdentity(file, input) {
    var explicit = clean(input && input.request_id);
    if (explicit) return explicit;
    var metadata = [
      clean(file && file.name),
      Number((file && file.size) || 0),
      clean(file && file.type),
      Number((file && file.lastModified) || 0),
    ].join('|');
    try {
      if (file && typeof file.arrayBuffer === 'function') {
        var digest = await sha256Bytes(await file.arrayBuffer(), metadata);
        return 'parse-' + digest.slice(0, 32);
      }
    } catch (_) {}
    return 'parse-' + (await sha256Text(metadata)).slice(0, 32);
  }

  function stableIdempotencyKey(prefix, requestId, input) {
    var explicit = clean(input && (input.idempotency_key || input.idempotencyKey));
    return explicit || prefix + ':' + clean(requestId);
  }

  function canonicalPath(path) {
    var raw = clean(path);
    if (raw.indexOf('/apps/gcity-api') === 0) return raw;
    try {
      if (window.GCITY_ROUTES && typeof window.GCITY_ROUTES.resolve === 'function')
        return window.GCITY_ROUTES.resolve(raw);
    } catch (_) {}
    var base = clean(
      (window.GCITY_ROUTES && window.GCITY_ROUTES.apiBase) || '/apps/gcity-api'
    ).replace(/\/+$/, '');
    return base + String(raw || '').replace(/^\/api/, '');
  }

  function accessToken() {
    var session = window.LittleGWebSession;
    if (
      !session ||
      typeof session.getState !== 'function' ||
      typeof session.getAccessToken !== 'function' ||
      session.getState().status !== 'authenticated'
    )
      return '';
    return clean(session.getAccessToken());
  }

  function trustedUploadPath(path) {
    var target = clean(path);
    return (
      target.indexOf('/apps/gcity-api/') === 0 &&
      target.indexOf('\\') === -1 &&
      !/%(?:2e|2f|5c)/i.test(target) &&
      !/(?:^|\/)\.{1,2}(?:\/|$|\?)/.test(target)
    );
  }

  function transportError(code, userMessage, status, retryable, requestId, retryAfterSeconds) {
    var error = new Error(userMessage || code || 'transport_error');
    error.code = clean(code || 'transport_error');
    error.status = Number(status || 0);
    error.user_message = clean(userMessage || '');
    error.retryable = retryable === true;
    error.request_id = clean(requestId || '');
    error.retry_after_seconds = Math.max(0, Number(retryAfterSeconds || 0));
    return error;
  }

  function abortError() {
    try {
      return new window.DOMException('The request was aborted.', 'AbortError');
    } catch (_) {
      var error = new Error('The request was aborted.');
      error.name = 'AbortError';
      return error;
    }
  }

  function emitTelemetry(phase, detail) {
    try {
      document.dispatchEvent(
        new CustomEvent('littleg:upload-transport-telemetry', {
          detail: Object.assign(
            {
              phase: phase,
              version: VERSION,
              timestamp: new Date().toISOString(),
            },
            detail || {}
          ),
        })
      );
    } catch (_) {}
  }

  function normalizeTransportFailure(error) {
    if (error && (error.name === 'AbortError' || clean(error.code))) return error;
    return transportError(
      'network_error',
      message('network'),
      Number((error && error.status) || 0),
      true,
      error && error.request_id
    );
  }

  async function withRequestDeadline(externalSignal, task) {
    if (externalSignal && externalSignal.aborted) throw abortError();
    var controller =
      typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var requestSignal = controller ? controller.signal : externalSignal || undefined;
    var timeoutId = 0;
    var externalAbortHandler = null;
    var timedOut = false;

    if (controller && externalSignal && typeof externalSignal.addEventListener === 'function') {
      externalAbortHandler = function () {
        if (!controller.signal.aborted) controller.abort();
      };
      externalSignal.addEventListener('abort', externalAbortHandler, { once: true });
    }

    var timeoutPromise = new Promise(function (_, reject) {
      timeoutId = window.setTimeout(function () {
        timedOut = true;
        if (controller && !controller.signal.aborted) controller.abort();
        reject(transportError('timeout', message('timeout'), 0, true));
      }, REQUEST_TIMEOUT_MS);
    });

    try {
      return await Promise.race([
        Promise.resolve().then(function () {
          return task(requestSignal);
        }),
        timeoutPromise,
      ]);
    } catch (error) {
      if (timedOut) throw transportError('timeout', message('timeout'), 0, true);
      throw normalizeTransportFailure(error);
    } finally {
      window.clearTimeout(timeoutId);
      if (
        externalSignal &&
        externalAbortHandler &&
        typeof externalSignal.removeEventListener === 'function'
      ) {
        externalSignal.removeEventListener('abort', externalAbortHandler);
      }
    }
  }

  function canonicalSuccess(payload, responseStatus) {
    if (!payload || typeof payload !== 'object' || payload.success !== true) {
      throw transportError(
        'invalid_response',
        message('invalidResponse'),
        responseStatus,
        true,
        payload && payload.request_id
      );
    }
    if (!payload.data || typeof payload.data !== 'object' || Array.isArray(payload.data)) {
      throw transportError(
        'invalid_response',
        message('missingData'),
        responseStatus,
        true,
        payload.request_id
      );
    }
    var data = Object.assign({}, payload.data);
    var requestId = clean(payload.request_id || data.request_id);
    if (!data.request_id && requestId) data.request_id = requestId;
    return { success: true, request_id: requestId, data: data };
  }

  function canonicalFailure(payload, response) {
    var rawFailure = payload && payload.error;
    var failure =
      rawFailure && typeof rawFailure === 'object' && !Array.isArray(rawFailure)
        ? rawFailure
        : {
            code: clean(rawFailure),
            message: clean(payload && payload.message),
            retryable:
              Number((response && response.status) || 0) === 429 ||
              Number((response && response.status) || 0) >= 500,
          };
    var retryAfter = Number(
      (response && response.headers && response.headers.get('Retry-After')) ||
        failure.retry_after_seconds ||
        0
    );
    return transportError(
      clean(failure.code) || 'request_failed',
      clean(failure.message) || message('requestFailed'),
      Number((response && response.status) || 0),
      failure.retryable === true,
      payload && payload.request_id,
      retryAfter
    );
  }

  async function readResponse(response) {
    var payload = await response.json().catch(function () {
      return null;
    });
    if (!response.ok || !payload || payload.success !== true)
      throw canonicalFailure(payload, response);
    return canonicalSuccess(payload, response.status);
  }

  function headers(idempotencyKey, jsonBody) {
    var value = {
      Accept: 'application/json',
      'X-Idempotency-Key': idempotencyKey || uid('notice'),
    };
    var token = accessToken();
    if (token) value.Authorization = 'Bearer ' + token;
    if (jsonBody) value['Content-Type'] = 'application/json';
    return value;
  }

  async function post(path, options, signal, idempotencyKey, operation, requestId) {
    if (window.navigator.onLine === false)
      throw transportError('offline', message('offline'), 0, true, requestId);
    var target = canonicalPath(path);
    if (!trustedUploadPath(target)) {
      throw transportError(
        'invalid_api_target',
        'The upload API target is not trusted.',
        403,
        false,
        requestId
      );
    }
    var startedAt = Date.now();
    emitTelemetry('start', { operation: operation, request_id: clean(requestId), path: path });
    try {
      var response = await withRequestDeadline(signal, function (requestSignal) {
        var requestOptions = Object.assign(
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: headers(idempotencyKey, options.jsonBody === true),
            signal: requestSignal,
          },
          options.request || {}
        );
        requestOptions.redirect = 'error';
        return window.fetch(target, requestOptions).then(readResponse);
      });
      emitTelemetry('success', {
        operation: operation,
        request_id: clean((response && response.request_id) || requestId),
        path: path,
        duration_ms: Date.now() - startedAt,
      });
      return response;
    } catch (error) {
      emitTelemetry('failure', {
        operation: operation,
        request_id: clean((error && error.request_id) || requestId),
        path: path,
        duration_ms: Date.now() - startedAt,
        code: clean(error && error.code),
        status: Number((error && error.status) || 0),
        retryable: !!(error && error.retryable),
      });
      throw error;
    }
  }

  function postForm(path, form, signal, idempotencyKey, operation, requestId) {
    return post(
      path,
      { request: { body: form }, jsonBody: false },
      signal,
      idempotencyKey,
      operation,
      requestId
    );
  }

  function postJson(path, body, signal, idempotencyKey, operation, requestId) {
    return post(
      path,
      { request: { body: JSON.stringify(body || {}) }, jsonBody: true },
      signal,
      idempotencyKey,
      operation,
      requestId
    );
  }

  function boundedInteger(value, maximum) {
    var parsed = Number.parseInt(String(value == null ? '' : value), 10);
    if (!Number.isFinite(parsed) || parsed < 0) return 0;
    return Math.min(parsed, maximum);
  }

  function routeParty(value) {
    var source = value && typeof value === 'object' ? value : {};
    return {
      guardian: clean(source.guardian).slice(0, 80) || null,
      note: clean(source.note).slice(0, 240) || null,
    };
  }

  function routeReadinessBody(input) {
    var source = input && typeof input === 'object' ? input : {};
    var packing =
      source.packing_cross_check && typeof source.packing_cross_check === 'object'
        ? source.packing_cross_check
        : {};
    var total = boundedInteger(packing.total, 500);
    var incomplete = Math.min(total, boundedInteger(packing.incomplete, 500));
    return {
      notice_record_id: clean(source.notice_record_id).slice(0, 120),
      destination_text: clean(source.destination_text).slice(0, 300),
      arrival_target: clean(source.arrival_target).slice(0, 80) || null,
      packing_cross_check: {
        total: total,
        incomplete: incomplete,
        ready: total > 0 && incomplete === 0,
      },
      guardian_responsibility: clean(source.guardian_responsibility).slice(0, 300) || null,
      dropoff: routeParty(source.dropoff),
      pickup: routeParty(source.pickup),
    };
  }

  function fieldMap(notice) {
    var map = {};
    var fields = notice && Array.isArray(notice.fields) ? notice.fields : [];
    fields.forEach(function (field) {
      if (!field || field.guardian_state === 'removed') return;
      var key = clean(field.key).toLowerCase();
      if (key) map[key] = clean(field.value);
    });
    return map;
  }

  function splitItems(value) {
    var seen = {};
    return clean(value)
      .split(/[\n,，、;；|]+/)
      .map(clean)
      .filter(function (item) {
        var key = item.toLowerCase();
        if (!item || seen[key]) return false;
        seen[key] = true;
        return true;
      });
  }

  function itemModels(values, group) {
    return values.map(function (name, index) {
      return {
        id: group + '-' + index + '-' + clean(name).toLowerCase().replace(/\s+/g, '-').slice(0, 40),
        name: name,
        note: group === 'suggested' ? message('suggestedNote') : '',
        group: group,
        checked: false,
        removed: false,
      };
    });
  }

  function localPacking(notice, requestId, reason) {
    var fields = fieldMap(notice);
    var required = [];
    ['required_items', 'bring_items', 'items', 'materials'].forEach(function (key) {
      required = required.concat(splitItems(fields[key]));
    });
    var activity = [
      fields.activity_name,
      fields.activity_type,
      fields.notes,
      notice && notice.raw_text,
    ]
      .map(clean)
      .join(' ')
      .toLowerCase();
    var suggested = [];
    function add(values) {
      suggested = suggested.concat(values);
    }
    if (/游泳|泳池|swim/.test(activity)) add(['泳衣', '泳帽', '毛巾', '水樽']);
    if (/運動|体育|體育|球賽|跑步|sport|football|basketball/.test(activity))
      add(['運動鞋', '水樽', '毛巾']);
    if (/旅行|戶外|户外|郊遊|郊游|參觀|参观|outing|field trip/.test(activity))
      add(['水樽', '帽', '輕便雨具']);
    if (/美術|美术|繪畫|绘画|手工|art|craft/.test(activity)) add(['文具', '保護衣物用圍裙']);
    if (/下雨|雨天|rain/.test(activity)) add(['雨具']);
    var requiredKeys = {};
    required.forEach(function (item) {
      requiredKeys[item.toLowerCase()] = true;
    });
    suggested = splitItems(suggested.join('|')).filter(function (item) {
      return !requiredKeys[item.toLowerCase()];
    });
    return {
      request_id: clean(requestId || (notice && notice.request_id)) || uid('packing-local'),
      required_items: itemModels(splitItems(required.join('|')), 'required'),
      suggested_items: itemModels(suggested, 'suggested'),
      custom_items: [],
      generation_mode: 'local_rule_engine_after_guardian_review',
      persistence: 'not_saved',
      warnings: [
        'remote_packing_unavailable:' + clean(reason || 'unknown'),
        'guardian_review_required',
      ],
    };
  }

  function localConfirmation(input, reason) {
    var familyData = window.LittleGFamilyData;
    if (!familyData || typeof familyData.saveRecord !== 'function') {
      throw transportError(
        'canonical_storage_owner_unavailable',
        message('storageUnavailable'),
        503,
        true
      );
    }
    var requestId = clean(input.request_id) || uid('notice-local');
    var record = familyData.saveRecord('notice', {
      result_id: 'family-notice-' + requestId,
      request_id: requestId,
      notice: input.notice || {},
      packing_list: input.packing_list || {},
      checklist: Array.isArray(input.checklist) ? input.checklist : [],
      status: 'private_local_saved',
      backend_submission_status: 'not_submitted',
      persistence: 'local_only',
      fallback_reason: clean(reason || 'remote_confirmation_unavailable'),
      confirmed_at: new Date().toISOString(),
      source: 'littleg-family-notice',
    });
    if (!record) throw transportError('local_save_failed', message('localSaveFailed'), 500, true);
    lastPersistence = 'local_only';
    return {
      request_id: requestId,
      status: message('localSaved'),
      confirmed_at: record.confirmed_at || new Date().toISOString(),
      persistence: 'local_only',
      record: record,
      warnings: ['backend_not_confirmed', clean(reason || 'remote_confirmation_unavailable')],
    };
  }

  function confirmationContext(response) {
    var data =
      response &&
      response.data &&
      typeof response.data === 'object' &&
      !Array.isArray(response.data)
        ? response.data
        : {};
    var source =
      data.confirmation &&
      typeof data.confirmation === 'object' &&
      !Array.isArray(data.confirmation)
        ? data.confirmation
        : data.record && typeof data.record === 'object' && !Array.isArray(data.record)
          ? data.record
          : data;
    var record =
      source.record && typeof source.record === 'object' && !Array.isArray(source.record)
        ? source.record
        : {};
    return { data: data, source: source, record: record };
  }

  function emitMirrorState(saved, detail) {
    try {
      document.dispatchEvent(
        new CustomEvent('littleg:family-record-mirror-state', {
          bubbles: true,
          detail: Object.assign(
            { saved: !!saved, source: 'assets/littleg-upload-transport.js', version: VERSION },
            detail || {}
          ),
        })
      );
    } catch (_) {}
  }

  function attachMirrorMetadata(response, mirrorRecord, failureReason) {
    var next = cloneJson(response, null) || response || { success: true, request_id: '', data: {} };
    if (!next.data || typeof next.data !== 'object' || Array.isArray(next.data)) next.data = {};
    var target;
    if (
      next.data.confirmation &&
      typeof next.data.confirmation === 'object' &&
      !Array.isArray(next.data.confirmation)
    )
      target = next.data.confirmation;
    else if (
      next.data.record &&
      typeof next.data.record === 'object' &&
      !Array.isArray(next.data.record)
    )
      target = next.data.record;
    else {
      next.data.confirmation = {};
      target = next.data.confirmation;
    }
    target.persistence = 'backend_confirmed';
    target.local_mirror_saved = !!mirrorRecord;
    target.local_record_id = mirrorRecord
      ? clean(mirrorRecord.record_id || mirrorRecord.result_id || mirrorRecord.card_id)
      : '';
    target.local_mirror_failure_reason = mirrorRecord
      ? ''
      : clean(failureReason || 'local_mirror_failed');
    if (
      mirrorRecord &&
      (!target.record || typeof target.record !== 'object' || Array.isArray(target.record))
    )
      target.record = mirrorRecord;
    return next;
  }

  function mirrorBackendConfirmation(input, response) {
    var familyData = window.LittleGFamilyData;
    var context = confirmationContext(response);
    var source = context.source;
    var remoteRecord = context.record;
    var requestId =
      clean(
        (response && response.request_id) ||
          source.request_id ||
          source.requestId ||
          remoteRecord.request_id ||
          remoteRecord.requestId ||
          (input && input.request_id)
      ) || uid('notice-remote');
    var recordId =
      clean(
        source.record_id ||
          source.result_id ||
          source.card_id ||
          source.id ||
          remoteRecord.record_id ||
          remoteRecord.result_id ||
          remoteRecord.card_id ||
          remoteRecord.id
      ) || 'family-notice-' + requestId;
    var confirmedAt =
      clean(
        source.confirmed_at ||
          source.confirmedAt ||
          remoteRecord.confirmed_at ||
          remoteRecord.confirmedAt
      ) || new Date().toISOString();

    if (!familyData || typeof familyData.saveRecord !== 'function') {
      emitMirrorState(false, {
        reason: 'canonical_family_data_owner_unavailable',
        request_id: requestId,
        record_id: recordId,
      });
      return {
        record: null,
        response: attachMirrorMetadata(response, null, 'canonical_family_data_owner_unavailable'),
      };
    }

    var mirrorRecord = null;
    var failureReason = '';
    try {
      mirrorRecord = familyData.saveRecord(
        'notice',
        Object.assign({}, remoteRecord, {
          result_id: recordId,
          record_id: recordId,
          card_id: recordId,
          request_id: requestId,
          notice:
            input && input.notice && typeof input.notice === 'object'
              ? cloneJson(input.notice, {})
              : cloneJson(remoteRecord.notice, {}),
          packing_list:
            input && input.packing_list && typeof input.packing_list === 'object'
              ? cloneJson(input.packing_list, {})
              : cloneJson(remoteRecord.packing_list, {}),
          checklist:
            input && Array.isArray(input.checklist)
              ? cloneJson(input.checklist, [])
              : cloneJson(Array.isArray(remoteRecord.checklist) ? remoteRecord.checklist : [], []),
          status: clean(source.status || remoteRecord.status || 'confirmed'),
          backend_submission_status: 'confirmed',
          persistence: 'backend_confirmed',
          confirmed_at: confirmedAt,
          source: 'littleg-family-notice',
          mirror_source: 'remote_confirm_success',
        })
      );
      if (!mirrorRecord) failureReason = 'canonical_local_record_save_failed';
    } catch (error) {
      failureReason =
        clean(error && (error.code || error.message)) || 'canonical_local_record_save_failed';
    }

    emitMirrorState(!!mirrorRecord, {
      reason: failureReason,
      request_id: requestId,
      record_id: recordId,
      local_record_id: mirrorRecord
        ? clean(mirrorRecord.record_id || mirrorRecord.result_id || mirrorRecord.card_id)
        : '',
      persistence: 'backend_confirmed',
    });
    return {
      record: mirrorRecord,
      response: attachMirrorMetadata(response, mirrorRecord, failureReason),
    };
  }

  function fallbackReason(error) {
    var code = clean(error && error.code);
    var status = Number((error && error.status) || 0);
    return code || (Number.isFinite(status) && status ? 'http_' + status : 'network_unavailable');
  }

  function canUseLocalFallback(error) {
    if (!error) return true;
    if (error.name === 'AbortError') return false;
    var status = Number(error.status || 0);
    var code = clean(error.code).toLowerCase();
    if (Number.isFinite(status) && status >= 400 && status < 500) return false;
    if (
      /(auth|unauthor|forbidden|permission|session|validation|invalid|conflict|duplicate|rate|quota|csrf|idempotency)/.test(
        code
      )
    )
      return false;
    if (Number.isFinite(status) && status >= 500) return true;
    if (!status && !code) return true;
    return (
      [
        'offline',
        'network_error',
        'network_unavailable',
        'fetch_failed',
        'provider_unavailable',
        'service_unavailable',
        'timeout',
        'gateway_timeout',
      ].indexOf(code) !== -1
    );
  }

  function registerConfirmContributor(name, contributor, priority) {
    var key = clean(name);
    if (!key || typeof contributor !== 'function')
      throw new TypeError('invalid_confirm_contributor');
    confirmContributors.set(key, {
      name: key,
      priority: Number.isFinite(Number(priority)) ? Number(priority) : 100,
      contribute: contributor,
    });
    return function unregister() {
      confirmContributors.delete(key);
    };
  }

  function unregisterConfirmContributor(name) {
    return confirmContributors.delete(clean(name));
  }

  function listConfirmContributors() {
    return Array.from(confirmContributors.values())
      .sort(function (left, right) {
        return left.priority - right.priority || left.name.localeCompare(right.name);
      })
      .map(function (entry) {
        return { name: entry.name, priority: entry.priority };
      });
  }

  async function composeConfirmInput(input) {
    var payload = cloneConfirmInput(input);
    var entries = Array.from(confirmContributors.values()).sort(function (left, right) {
      return left.priority - right.priority || left.name.localeCompare(right.name);
    });
    for (var index = 0; index < entries.length; index += 1) {
      var next = await entries[index].contribute(payload);
      if (next && typeof next === 'object') payload = next;
      if (!payload.notice || typeof payload.notice !== 'object') payload.notice = {};
      if (!payload.packing_list || typeof payload.packing_list !== 'object')
        payload.packing_list = {};
      if (!Array.isArray(payload.checklist)) payload.checklist = [];
    }
    return payload;
  }

  function emitSuccess(method, input, response) {
    try {
      document.dispatchEvent(
        new CustomEvent('littleg:upload-transport-success', {
          detail: { method: method, input: input, response: response, version: VERSION },
        })
      );
    } catch (_) {}
    return response;
  }

  function handleUploadStateChange(event) {
    var detail = event && event.detail ? event.detail : {};
    if (detail.state !== 'records' || lastPersistence !== 'local_only') return;
    var root =
      event.target && event.target.closest
        ? event.target.closest('[data-littleg-upload-workspace]')
        : document.querySelector('[data-littleg-upload-workspace]');
    if (!(root instanceof HTMLElement)) return;
    root.setAttribute('data-record-persistence', 'local_only');
    root.setAttribute('data-upload-sync-state', 'pending');
    var status = root.querySelector('[data-record-save-status]');
    if (status) status.textContent = message('localStatus');
  }

  function dispose() {
    document.removeEventListener('littleg:upload-state-change', handleUploadStateChange);
  }

  var transport = {
    VERSION: VERSION,
    configured: true,
    mode: 'canonical-envelope-stable-parse-confirm-contributor-pipeline-f02-brief',
    localFallbackPolicy: 'offline-network-timeout-or-5xx-only',
    requestTimeoutMs: REQUEST_TIMEOUT_MS,
    paths: PATHS,
    dispose: dispose,
    registerConfirmContributor: registerConfirmContributor,
    unregisterConfirmContributor: unregisterConfirmContributor,
    listConfirmContributors: listConfirmContributors,
    composeConfirmInput: composeConfirmInput,
    stableParseIdentity: stableParseIdentity,

    getRouteReadinessBrief: async function (input) {
      var body = routeReadinessBody(input);
      if (!body.notice_record_id)
        throw transportError('validation_failed', message('missingRouteRecord'), 422, false);
      if (!body.destination_text)
        throw transportError('validation_failed', message('missingDestination'), 422, false);
      var requestId = await stableRequestId('route-readiness', input, body);
      var idempotencyKey = stableIdempotencyKey('route-readiness', requestId, input);
      return emitSuccess(
        'getRouteReadinessBrief',
        {
          notice_record_id: body.notice_record_id,
          has_destination: true,
          has_arrival_target: !!body.arrival_target,
          packing_total: body.packing_cross_check.total,
          packing_incomplete: body.packing_cross_check.incomplete,
        },
        await postJson(
          PATHS.routeReadinessBrief,
          body,
          input && input.signal,
          idempotencyKey,
          'getRouteReadinessBrief',
          requestId
        )
      );
    },

    parseNotice: async function (input) {
      var file = input && input.file;
      if (!file) throw transportError('invalid_file', message('invalidFile'), 400, false);
      var requestId = await stableParseIdentity(file, input || {});
      var idempotencyKey = stableIdempotencyKey('parse', requestId, input || {});
      var form = new FormData();
      form.append('file', file, file.name || 'notice');
      form.append('request_id', requestId);
      form.append('source', clean((input && input.source) || 'unknown'));
      form.append('document_type', 'school_notice');
      form.append('contract', 'NOTICE_PARSE_INPUT_V1');
      form.append('locale', document.documentElement.lang || 'zh-HK');
      return emitSuccess(
        'parseNotice',
        input,
        await postForm(
          PATHS.parse,
          form,
          input && input.signal,
          idempotencyKey,
          'parseNotice',
          requestId
        )
      );
    },

    generatePackingList: async function (input) {
      var body = { notice: (input && input.notice) || {}, contract: 'NOTICE_JSON_INPUT_V1' };
      body.request_id = await stableRequestId('packing', input, body);
      var idempotencyKey = stableIdempotencyKey('packing', body.request_id, input);
      try {
        return emitSuccess(
          'generatePackingList',
          input,
          await postJson(
            PATHS.packing,
            body,
            input && input.signal,
            idempotencyKey,
            'generatePackingList',
            body.request_id
          )
        );
      } catch (error) {
        if (!canUseLocalFallback(error)) throw error;
        var reason = fallbackReason(error);
        var fallback = localPacking(body.notice, body.request_id, reason);
        return emitSuccess('generatePackingList', input, {
          success: true,
          request_id: fallback.request_id,
          data: { packing_list: fallback },
        });
      }
    },

    confirmNotice: async function (input) {
      var payload = await composeConfirmInput(input);
      var body = {
        notice: payload.notice || {},
        packing_list: payload.packing_list || {},
        checklist: Array.isArray(payload.checklist) ? payload.checklist : [],
        contract: 'NOTICE_CONFIRM_INPUT_V1',
        visibility: 'private',
        parent_confirmed: true,
        consent_version: clean(payload.consent_version || 'family-notice-v1'),
        privacy_policy_version: clean(payload.privacy_policy_version || '2026-08-01'),
      };
      body.request_id = await stableRequestId('confirm', payload, body);
      var idempotencyKey = stableIdempotencyKey('confirm', body.request_id, payload);
      try {
        var response = await postJson(
          PATHS.confirm,
          body,
          payload.signal,
          idempotencyKey,
          'confirmNotice',
          body.request_id
        );
        var mirrorResult = mirrorBackendConfirmation(body, response);
        lastPersistence = 'backend_confirmed';
        return emitSuccess('confirmNotice', payload, mirrorResult.response);
      } catch (error) {
        if (!canUseLocalFallback(error)) throw error;
        var reason = fallbackReason(error);
        var fallback = localConfirmation(body, reason);
        return emitSuccess('confirmNotice', payload, {
          success: true,
          request_id: fallback.request_id,
          data: { confirmation: fallback },
        });
      }
    },
  };

  window.LittleGUploadTransport = transport;
  document.addEventListener('littleg:upload-state-change', handleUploadStateChange);

  try {
    document.dispatchEvent(
      new CustomEvent('littleg:upload-transport-ready', {
        detail: {
          version: VERSION,
          configured: true,
          ocr_mode: 'remote_fail_closed',
          envelope: 'canonical_v1',
          parse_idempotency: 'stable_file_hash_v1',
          confirm_pipeline: 'contributors_v1',
          f02_brief: 'authenticated_notice_record_context_v1',
          request_timeout_ms: REQUEST_TIMEOUT_MS,
          local_fallback_policy: 'offline_network_timeout_or_5xx_only',
          telemetry: 'pii_free_events_v1',
        },
      })
    );
  } catch (_) {}
})(window, document);
